import axios from 'axios';

const API_URL = '/api/orders/';

// Initiate Stripe payment
const initiateStripe = async (orderData) => {
    const response = await axios.post(API_URL + 'initiate-stripe', orderData);
    return response.data;
};

// Get order by session ID (for success page)
const getOrderBySessionId = async (sessionId) => {
    const response = await axios.get(API_URL + 'session/' + sessionId);
    return response.data;
};

const getAdminOrders = async ({ page = 1, limit = 20, includeUnpaidCancelled = false } = {}) => {
    const token = JSON.parse(localStorage.getItem('user')).token;
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        params: {
            page,
            limit,
            includeUnpaidCancelled,
        },
    };
    const response = await axios.get(API_URL, config); 
    return response.data;
};

const getAdminOrderById = async (orderId) => {
    const token = JSON.parse(localStorage.getItem('user')).token;
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const response = await axios.get(`${API_URL}${orderId}`, config);
    return response.data;
};

const updateOrderStatus = async (orderId, status) => {
    const token = JSON.parse(localStorage.getItem('user')).token;
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const response = await axios.put(API_URL + 'status', { orderId, status }, config); 
    return response.data;
};

const getAdminOrderSummary = async () => {
    const token = JSON.parse(localStorage.getItem('user')).token;
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const response = await axios.get(API_URL + 'summary', config);
    return response.data;
};

const getOmnivaLocations = async () => {
    const response = await axios.get('/api/shipping/locations/omniva');
    return response.data;
};

const orderService = {
    initiateStripe,
    getOrderBySessionId,
    getAdminOrders,
    getAdminOrderById,
    updateOrderStatus,
    getAdminOrderSummary,
    getOmnivaLocations
};

export default orderService;
